import { render, staticRenderFns } from "./FaultStatus.vue?vue&type=template&id=6861005f&scoped=true"
import script from "./FaultStatus.vue?vue&type=script&lang=js"
export * from "./FaultStatus.vue?vue&type=script&lang=js"
import style0 from "./FaultStatus.vue?vue&type=style&index=0&id=6861005f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6861005f",
  null
  
)

export default component.exports